import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { enrichedActionApiToEnrichedActionEntity, enrichedActionToEnrichedActionApi } from '../../entities/EnrichedAction';
import { BaseClient } from '../BaseClient';
export class EnrichedActionClientBase extends BaseClient {
  constructor() {
    super(...arguments);
    _defineProperty(this, "getEnrichedActionImpl", void 0);
    _defineProperty(this, "updateEnrichedActionImpl", void 0);
  }
  async getEnrichedAction(actionId) {
    try {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      const {
        enrichedAction
      } = await this.request(this.getEnrichedActionImpl({
        actionId
      }), ...args);
      return this.convertToEntity(enrichedAction);
    } catch (error) {
      this.logError('getEnrichedAction', 'Failed to get enriched action', {
        actionId
      }, error);
      throw error;
    }
  }
  async updateEnrichedAction(data) {
    try {
      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }
      const {
        enrichedAction
      } = await this.request(this.updateEnrichedActionImpl({
        enrichedAction: enrichedActionToEnrichedActionApi(data)
      }), ...args);
      return this.convertToEntity(enrichedAction);
    } catch (error) {
      this.logError('updateEnrichedAction', 'Failed to update enriched action', {
        data
      }, error);
      throw error;
    }
  }
  convertToEntity(action) {
    try {
      return enrichedActionApiToEnrichedActionEntity(action);
    } catch (error) {
      this.logError('convertToEntity', 'Failed to convert action', {
        action
      }, error);
      throw error;
    }
  }
  getServiceNameForLogs() {
    return 'EnrichedActionClient';
  }
}
//# sourceMappingURL=EnrichedActionClientBase.js.map